module.exports = __webpack_public_path__ + "static/media/huawei_battery_2.7e6c5ba8.png";